/**
 * Mobile collection bar: fixed while browsing products; docks below grid at list end.
 */
const MQ = window.matchMedia('(max-width: 749px)');

/** @type {(() => void) | undefined} */
let update;
/** @type {ResizeObserver | undefined} */
let resizeObs;
let ticking = false;

function teardown() {
  if (update) {
    window.removeEventListener('scroll', update);
    update = undefined;
  }
  resizeObs?.disconnect();
  resizeObs = undefined;
  ticking = false;
}

function init() {
  teardown();
  if (!MQ.matches) return;

  const bar = document.getElementById('cw-mobile-bottombar');
  const grid = document.getElementById('ResultsList');
  const host = grid?.parentElement;
  if (!bar || !grid || !host) return;

  let sentinel = host.querySelector('.cw-mobile-bottombar-sentinel');
  if (!sentinel) {
    sentinel = document.createElement('div');
    sentinel.className = 'cw-mobile-bottombar-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
  }

  grid.insertAdjacentElement('afterend', sentinel);
  sentinel.insertAdjacentElement('afterend', bar);

  function checkDocked() {
    ticking = false;
    const endReached = sentinel.getBoundingClientRect().top <= window.innerHeight;
    bar.classList.toggle('is-docked', endReached);
  }

  update = () => {
    if (!ticking) {
      requestAnimationFrame(checkDocked);
      ticking = true;
    }
  };

  bar.classList.remove('is-docked');
  checkDocked();

  window.addEventListener('scroll', update, { passive: true });
  resizeObs = new ResizeObserver(update);
  resizeObs.observe(grid);
}

function scheduleInit() {
  requestAnimationFrame(() => setTimeout(init, 50));
}

MQ.addEventListener('change', init);
document.addEventListener('filter:update', scheduleInit);
document.addEventListener('shopify:section:load', scheduleInit);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
